"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@material-ui/core");

var react_1 = __importDefault(require("react"));

var BB8MainPage_1 = __importDefault(require("./BB8MainPage"));

var styles = core_1.createStyles(function (theme) {
  return {
    container: {
      display: 'grid',
      gridGap: theme.spacing.unit * 3 + "px",
      gridTemplateAreas: "\"default default default default action\"",
      gridTemplateColumns: 'repeat(4, 1fr) minmax(130px, auto)',
      gridTemplateRows: '78px',
      width: '100%'
    },
    content: {
      padding: 0
    },
    divider: {
      margin: theme.spacing.unit * 2 + "px 0"
    },
    paper: {
      color: theme.palette.text.secondary,
      marginBottom: theme.spacing.unit,
      padding: theme.spacing.unit,
      textAlign: 'center',
      whiteSpace: 'nowrap'
    }
  };
});

var BB8SummaryRow = function BB8SummaryRow(_a) {
  var children = _a.children,
      classes = _a.classes;
  return react_1.default.createElement(BB8MainPage_1.default.Padded, null, react_1.default.createElement("div", {
    className: classes.container
  }, children));
};

exports.default = core_1.withStyles(styles)(BB8SummaryRow);